export default [
	//重定向
	{
		path    : "/",
		redirect: "/newShopList"
	},
	// {
	//   path: "/home",
	//   component: () =>
	//     import(/* webpackChunkName: "login_home_welcome" */ "@/views/home"),
	//   name: "home",
	// },
	{
		path     : "/newShopList",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/newShopList"
			),
		name: "newShopList"
	},
	{
		path     : "/rechargeAgreement",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/rechargeAgreement.vue"
			),
		name: "rechargeAgreement"
	},
	{
		path     : "/shopList",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/native/shopList.vue"
			),
		name: "shopList"
	},
	{
		path     : "/orderList",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/order/orderList.vue"
			),
		name: "orderList"
	},
	{
		path     : "/orderStatus",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/order/orderStatus.vue"
			),
		name: "orderStatus"
	},
	{
		path     : "/otherPay",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/order/otherPay.vue"
			),
		name: "otherPay"
	},
	{
		path     : "/membershipAgreement",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/membershipAgreement.vue"
			),
		name: "membershipAgreement"
	},
	{
		path     : "/numberPayment",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/order/numberPayment.vue"
			),
		name: "numberPayment"
	},
	{
		path     : "/qanda",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/qanda.vue"
			),
		name: "qanda"
	},
	{
		path     : "/inviteFriends",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/inviteFriends.vue"
			),
		name: "inviteFriends"
	},
	{
		path     : "/inviteOthers",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/inviteOthers.vue"
			),
		name: "inviteOthers"
	},
	{
		path     : "/whatsapp",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/whatsapp.vue"
			),
		name: "whatsapp"
	},
	{
		path     : "/newTopUp",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/newTopUp.vue"
			),
		name: "newTopUp"
	},
	{
		path     : "/newTopUpOld",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/newTopUpOld.vue"
			),
		name: "newTopUpOld"
	},
	{
		path     : "/topUp",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/native/topUp.vue"
			),
		name: "topUp"
	},
	{
		path     : "/timeOffer",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/native/timeOffer.vue"
			),
		name: "timeOffer"
	},
	{
		path     : "/newTimeOffer",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/newTimeOffer.vue"
			),
		name: "newTimeOffer"
	},
	{
		path     : "/limitedTimeRecharge",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/limitedTimeRecharge.vue"
			),
		name: "limitedTimeRecharge"
	},
	{
		path     : "/newOrderStatus",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/order/newOrderStatus.vue"
			),
		name: "newOrderStatus"
	},
	{
		path     : "/paywall",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/native/paywall.vue"
			),
		name: "paywall"
	},
	{
		path     : "/newpaywall",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/newpaywall.vue"
			),
		name: "newpaywall"
	},
	{
		path     : "/activityManagement",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/activityManagement.vue"
			),
		name: "activityManagement"
	},
	{
		path     : "/questionnaire",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/questionnaire.vue"
			),
		name: "questionnaire"
	},
	//预加载路由
	{
		path     : "/preload",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/preload.vue"
			),
		name: "preload"
	},
	{
		path     : "/rechargeActivity",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/rechargeActivity.vue"
			),
		name: "rechargeActivity"
	},
	{
		path     : "/rechargeActivityResult",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/rechargeActivityResult.vue"
			),
		name: "rechargeActivityResult"
	},
	{
		path     : "/redemptionDownload",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/redemptionDownload.vue"
			),
		name: "redemptionDownload"
	},
	{
		path     : "/inviteActivityResult",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/inviteActivityResult.vue"
			),
		name: "inviteActivityResult"
	},
	{
		path     : "/gameStart",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/gameStart.vue"
			),
		name: "gameStart"
	},
	{
		path     : "/userCancellationAgreement",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/userCancellationAgreement.vue"
			),
		name: "userCancellationAgreement"
	},
	{
		path     : "/inviteActivity",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/inviteActivity.vue"
			),
		name: "inviteActivity"
	},
	{
		path     : "/inviteActivityWay",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/inviteActivityWay.vue"
			),
		name: "inviteActivityWay"
	},
	{
		path     : "/shareInviteFriends",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/shareInviteFriends.vue"
			)
	},
	{
		path     : "/gamesRecharge",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/gamesRecharge.vue")
	},
	{
		path     : "/activityquestionnaire",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/activityquestionnaire.vue"
			)
	},
	{
		path     : "/christmasEvent",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/christmasEvent.vue"
			)
	},
	{
		path     : "/specialOffer",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/specialOffer.vue"
			)
	},
	{
		path     : "/shareBonus",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/shareBonus.vue"
			)
	},
	{
		path     : "/sharePeople",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/sharePeople.vue"
			)
	},
	{
		path     : "/shareCatView",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/shareCatView.vue"
			)
	},
	{
		path     : "/mianPage",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/mianPage.vue"
			)
	},
	{
		path     : "/touchPage",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/touchPage.vue"
			)
	},
	{
		path     : "/catBookPage",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/catBookPage.vue"
			)
	},
	{
		path     : "/zanRecordPage",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/zanRecordPage.vue"
			)
	},
	{
		path     : "/setFavoriteDrama",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/setFavoriteDrama.vue"
			)
	},
	{
		path     : "/otherCat",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/otherCat.vue"
			)
	},
	{
		path     : "/catbag",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/catGame/catbag.vue"
			)
	},
	{
		path     : "/careerSurvey",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/careerSurvey.vue"
			)
	},
	{
		path     : "/financeH5",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/financeH5.vue"
			)
	},
	{
		path     : "/financeShowH5",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/thirdParty/financeShowH5.vue"
			)
	},
	{
		path     : "/yearlyReport",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/yearlyReport.vue"
			)
	},
	{
		path     : "/yearlyDownload",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/yearlyDownload.vue"
			)
	},
	{
		path     : "/valentineDay",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/valentineDay.vue"
			)
	},
	{
		path     : "/valentineDayChange",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/valentineDayChange.vue"
			)
	},
	{
		path     : "/valentineDayDown",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/valentineDayDown.vue"
			)
	},
	{
		path     : "/valentineDayDetail",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/valentineDayDetail.vue"
			)
	},
	{
		path     : "/valentineDayEvent",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/otherPage/valentineDayEvent.vue"
			)
	},
	{
		path     : "/caimH5",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/caimH5.vue"
			)
	},
	{
		path     : "/caimInvite",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/caimInvite.vue"
			)
	},
	{
		path     : "/caimlist",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/caimList.vue"
			)
	},
	{
		path     : "/Ramadan2026",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/Ramadan2026.vue"
			)
	},
	{
		path     : "/sacrifice2026",
		component: () =>
			import(
				/* webpackChunkName: "login_home_welcome" */ "@/views/caimActivity/sacrifice.vue"
			)
	}
]